export class Account {
  account: any;
  password: any;
}

export class SignUpAccount {
  full_name: any;
  email: any;
  password: any;
  phone_number: any;
  device_os: any;
  deal_alerts: number = 0;
}

export class Address {
  address_id: number;
  street: string;
  line2: string;
  city: string;
  address: string;
  zip_code: string;
  state: string;
  is_default: number = 0;
  lat: number;
  lng: number;
}

export const LOGIN_MIN_LENGTH = 4;
export const PASSWORD_MIN_LENGTH = 6;
